import { FoilType } from "../models/CardFinish";

export function getRandom<T>(items: T[]): T | null {
    if (!items || !items.length) {
        return null;
    }

    return items[(Math.floor(Math.random() * items.length))];
}

export function getTcgPlayerUrl(props: {
    tcgPlayerId: number,
    finish: FoilType
}): string {
    return props.tcgPlayerId > 0
        ? `https://partner.tcgplayer.com/3JJrgM?u=${encodeURIComponent(`https://www.tcgplayer.com/product/${props.tcgPlayerId}?Language=English${props.finish === "base" ? "&Printing=Normal" : "&Printing=Foil"}&Condition=Near+Mint`)}`
        : "https://partner.tcgplayer.com/3JJrgM?u=https://www.tcgplayer.com/search/final-fantasy-tcg/product?productLineName=final-fantasy-tcg&view=grid";
}

export function isTruthy(value: unknown): boolean {
    return value !== undefined && value !== null;
}